module.exports = __webpack_public_path__ + "static/media/texture-wood-dark-brown.2f0aca60.jpg";